// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /recebimentos/delete
 *
 * Returns the deleted recebimento ID.
 *
 * DO NOT EDIT THIS FILE MANUALLY — it is the single source of truth for the
 * response shape. The TypeScript sibling is auto-generated from this file via
 * scripts/sync-contracts/sync-from-php.sh.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Recebimentos_DeleteResponseDados = number;

export type Recebimentos_DeleteResponse = ApiResponse<Recebimentos_DeleteResponseDados>;

registerResponseContract('Recebimentos_DeleteResponse', {})
